import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  //PlainText,
  SummaryText,
  TakeawayMessages,
  SkipSection,
  ReagentDragDrop,
  GelDragDrop,
  //GelResults,
  MaterialsList,
  FullWidthCard,
  SubHeading,
  Heading,
  QuestionCSCQ,
  QuestionColor,
  FullWidthImage,
  FullWidthAnimation,
  ProtocolTableActual,
  ProtocolTableIdeal
} from "@learningblocks/exp-components";
// import {
//   HighlightHTML,
//   GlossaryProvider,
// } from "@learningblocks/storybook-components";
import { COMPONENT_TYPE } from "@learningblocks/protocol-constants/lib/Utilities";
//import { getContentDetails } from "../../../../../../../GlossaryAPI";

import "./style.scss";

import PopupIcon from "./img/Popup-icon.svg"

//const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

export class PopupQuestion extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  doneClicked =()=>{
    this.props.showModal({
      display: false
    })
  }

  renderByType = (component, key) => {
    switch (component.type) {
      // case COMPONENT_TYPE.PLAIN_TEXT:
      //   return (
      //     <div style={{lineHeight: 1.5, color: "#333"}}>
      //       <HighlightHTML
      //         key={key}
      //         content={component.text}
      //         getContentData={getContentDetails}
      //         openGlossary={onOpenGlossary}
      //       />
      //     </div>
      //   );
      case COMPONENT_TYPE.REAGENT_DRAG_DROP:
        return <ReagentDragDrop key={key} {...component} />;
      case COMPONENT_TYPE.GEL_DRAG_DROP:
        return <GelDragDrop key={key} {...component} />;
      case COMPONENT_TYPE.MATERIALS_LIST:
        return <MaterialsList key={key} {...component} />;
      case COMPONENT_TYPE.SKIP_SECTION:
        return <SkipSection key={key} {...component} />;
      case COMPONENT_TYPE.SUMMARY_TEXT:
        return <SummaryText key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_ACTUAL:
        return <ProtocolTableActual key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_IDEAL:
        return <ProtocolTableIdeal key={key} {...component} />;
      case COMPONENT_TYPE.TAKEAWAY_MESSAGES:
        return <TakeawayMessages key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return (
          <FullWidthImage
            key={key}
            className="fullWidthImage-item"
            {...component}
          />
        );
      case COMPONENT_TYPE.FULL_WIDTH_ANIMATION:
        return (
          <FullWidthAnimation
            key={key}
            className="fullWidthAnimation-item"
            {...component}
          />
        );
      case COMPONENT_TYPE.SUB_HEADING:
        return <SubHeading key={key} {...component} />;
      case COMPONENT_TYPE.HEADING:
        return <Heading key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return <FullWidthCard key={key} {...component} />;
      case COMPONENT_TYPE.CSCQ:
      case COMPONENT_TYPE.DDQ:
      case COMPONENT_TYPE.MSCQ:
      case COMPONENT_TYPE.OEQ:
      case COMPONENT_TYPE.NEQ:
        return <QuestionCSCQ key={key} {...component} />;
      case COMPONENT_TYPE.DNDQ_COLOR:
      case COMPONENT_TYPE.CSCQ_COLOR:
      case COMPONENT_TYPE.GROUPED_DNDQ:
        return <QuestionColor key={key} {...component} />;
      default:
        return null;
    }
  };

  render() {

    return (
      <div className="modal-section popup-question" style={{ width: "calc(100% - 0px)", height: "650px", margin: "auto" }}>
        <div className="modal-header">
          <img src={PopupIcon} alt="Popup icon." style={{marginRight: "16px"}}/>
          <h2>Pop Up Question</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner">
            {this.props.components.map(this.renderByType)}
          </div>
        </div>

        {/*<div className="modal-footer">

          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={this.doneClicked}>
              Done
          </button>

        </div>*/}
      </div>

    );
  }
}

PopupQuestion.propTypes = {
  components: PropTypes.array.isRequired,
};
